export function positionBaseCanvas(canvas, parentContainer) {
  //NOTE! Basecanvas should be CENTERED on parent container - It acts as the port panel and
  //can be bigger than it.
  canvas.style.top = Math.floor(parentContainer.top) + "px";
  canvas.style.left = Math.floor(parentContainer.left) + "px";
}
